import React, { useState, useEffect } from 'react';
import NhsLogo from '@assets/logos/nhs_logo.png';
import { getErrorMessage } from '@utils/commons';
import { useErrors } from '@contexts/ErrorsContext';

interface NhsNumberProps {
  nhsNumber: string;
  setNhsNumber: (value: string) => void;
}

export const validateNhsNumber = (nhsNumber: string) => {
  if (nhsNumber.length > 0 && nhsNumber.length < 10) {
    return 'The NHS number should contain 10 digits';
  }
  return null;
};

const NhsNumber: React.FC<NhsNumberProps> = ({ nhsNumber, setNhsNumber }) => {
  const [nhsNumberErrorMessage, setNhsNumberErrorMessage] = useState<
    string | undefined
  >('');
  const { errors } = useErrors();

  useEffect(() => {
    setNhsNumberErrorMessage(getErrorMessage(errors, 'nhsNumber'));
  }, [errors]);

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <img src={NhsLogo} width={190} alt={NhsLogo} className="mb-5 md:mb-10" />
      <div
        className={`govuk-form-group mt-10 govuk-bp:mt-14 ${nhsNumberErrorMessage ? 'govuk-form-group--error' : ''}`}
      >
        <h1 className="govuk-label-wrapper">
          <label className="govuk-label govuk-label--l" htmlFor="nhsNumber">
            What is your NHS number?
          </label>
        </h1>
        <div id="nhs-number-hint" className="govuk-hint">
          Your NHS number is a 10 digit number that you find on any letter the
          NHS has sent you. For example, 485 777 3456.
        </div>
        {nhsNumberErrorMessage && (
          <p id="nhs-input-error" className="govuk-error-message">
            <span className="govuk-visually-hidden">Error:</span>
            {nhsNumberErrorMessage}
          </p>
        )}
        <input
          className={`govuk-input govuk-input--width-20 ${nhsNumberErrorMessage ? 'govuk-input--error' : ''}`}
          id="nhsNumber"
          name="nhsNumber"
          type="text"
          autoComplete="nhsNumber"
          aria-describedby="nhs-number"
          value={nhsNumber ?? ''}
          onChange={e => {
            const { value } = e.target;
            if (/^[0-9]*$/.test(value) && value.length <= 10) {
              setNhsNumber(value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default NhsNumber;
